import { isAIGenPhoto } from '@mixtiles/web-backend-shared/dist/src/utils/tiles'
import { type Tile } from 'components/TilesProvider/TilesProvider.types'
import { type Template } from 'server/ai/consts'
import { getBaseSlug } from './AICreationPage.utils'
import { type AiTemplateType } from 'types/ai/template-schema'

const MULTI_INPUT_DYNAMIC_WALL_TEMPLATE_TYPES = new Set([
  'MULTI_INPUT_DYNAMIC_WALL',
  'MULTI_INPUT_DYNAMIC_WALL_12x16',
  'MULTI_INPUT_DYNAMIC_WALL_20x27',
])
export function isMultiInputTemplateType(templateType: AiTemplateType) {
  return MULTI_INPUT_DYNAMIC_WALL_TEMPLATE_TYPES.has(templateType)
}

const FORM_INPUT_TEMPLATE_TYPES = new Set<AiTemplateType>([
  'FORM_INPUT_DYNAMIC_WALL',
])
export function isFormInputTemplateType(templateType: AiTemplateType) {
  return FORM_INPUT_TEMPLATE_TYPES.has(templateType)
}

export function getTemplateAnalyticsProps(
  template: Template,
  templateIndex?: number,
  variant?: string
) {
  return {
    'Template ID': template.slug,
    'Base Slug': getBaseSlug(template),
    'Template Name': template.name,
    'Template Index': templateIndex,
    'Template Category': template.category,
    'Template Type': template.template_type,
    Variant: variant,
  }
}

export function getAIGenPhotoTileAnalyticsProps(tile: Tile) {
  if (!isAIGenPhoto(tile) || !tile.aiTemplate) {
    return {}
  }

  return {
    'Template ID': tile.aiTemplate.templateId,
    'Base Slug': tile.aiTemplate.baseSlug ?? tile.aiTemplate.templateId,
    'Template Name': tile.aiTemplate.templateName,
    'Template Index': tile.aiTemplate.templateIndex,
    'Template Type': tile.aiTemplate.templateType,
    'Template Category': tile.aiTemplate.templateCategory,
    Text: tile.aiTemplate.userText,
    'Job ID': tile.aiTemplate.jobId,
    'Generation Duration Seconds': tile.aiTemplate.totalDurationSeconds,
    Variant: tile.aiTemplate.variant,
    'Result Index': tile.aiTemplate.resultIndex,
  }
}
